import { createErrorObject as createErrorObjectCommon, getErrorResponseCode as getErrorResponseCodeCommon, } from '@zurich-framework/core/errors';
import { FatalApiError } from './FatalApiError';
import { PermissionError } from './PermissionError';
export function getErrorSource(location) {
    return {
        location,
    };
}
export const createErrorObject = (className) => {
    switch (className) {
        case FatalApiError.className:
            return Object.create(FatalApiError.prototype);
        case PermissionError.className:
            return Object.create(PermissionError.prototype);
    }
    return createErrorObjectCommon(className);
};
export function getErrorResponseCode(error) {
    return error instanceof FatalApiError
        ? error.status
        : error instanceof PermissionError
            ? 403
            : getErrorResponseCodeCommon(error);
}
